//CORE
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';

//COMPONENT
import {AppComponent} from './app.component';
import {CoursePageComponent} from './course-page/course-page.component';
import {HomepageComponent} from './homepage/homepage.component';
import {LoginPageComponent} from './login-page/login-page.component';
import {ProfilePageComponent} from './profile-page/profile-page.component';


//MODULE
import {AppRoutingModule} from './app-routing.module';
import {ChartModule} from 'primeng/primeng';
import {MalihuScrollbarModule} from 'ngx-malihu-scrollbar/dist/lib';
import {SwiperModule} from 'angular2-useful-swiper';
// import {Ng4LoadingSpinnerModule} from 'ng4-loading-spinner'; DA ELIMINARE

//SERVICE
import {AppService} from './services/app.service';
import { MenuComponent } from './menu/menu.component';

//GUARD
import { AuthGuard } from "./guard/auth.guard";

// PIPE
import { CourseAndOdImgPipe } from './pipes/course-and-od-img.pipe';
import { OdImgPipe } from './pipes/od-img.pipe';
import { CourseBackgroundColorPipe } from './pipes/course-background-color.pipe';

@NgModule({
    declarations: [
        AppComponent,
        CoursePageComponent,
        HomepageComponent,
        LoginPageComponent,
        ProfilePageComponent,
        MenuComponent,
        CourseAndOdImgPipe,
        OdImgPipe,
        CourseBackgroundColorPipe,
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        ChartModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        RouterModule,
        SwiperModule,
        MalihuScrollbarModule.forRoot(), 
        // Ng4LoadingSpinnerModule.forRoot() DA ELIMINARE
    ],
    providers: [
        AppService,
        AuthGuard,
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts